import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export const PAGE = { W: 794, H: 1123, M: 68, FOOT: 84 };
const SCALE = 2;

function cutPoints(body, contentH) {
  const top0 = body.getBoundingClientRect().top;
  const blocks = [...body.querySelectorAll("p, li, h1, h2, h3, h4, tr, img, blockquote, .keep")]
    .map((el) => { const r = el.getBoundingClientRect(); return [r.top - top0, r.bottom - top0]; });
  const breaks = [...body.querySelectorAll(".page-break")].map((el) => el.getBoundingClientRect().top - top0);
  const total = body.scrollHeight;
  const cuts = [];
  let start = 0;
  while (start < total - 1) {
    const limit = start + contentH;
    const brk = breaks.find((b) => b > start + 1 && b <= limit);
    let cut;
    if (brk !== undefined) cut = brk;
    else if (limit >= total) cut = total;
    else {
      const ok = blocks.map(([, b]) => b).filter((b) => b > start + 40 && b <= limit);
      cut = ok.length ? Math.max(...ok) : limit;
    }
    cuts.push([start, cut]);
    start = brk !== undefined ? brk + 2 : cut;
  }
  return cuts.length ? cuts : [[0, total]];
}

function wrap(ctx, text, maxW) {
  const out = [];
  let line = "";
  text.split(/\s+/).forEach((w) => {
    const t = line ? `${line} ${w}` : w;
    if (ctx.measureText(t).width > maxW && line) { out.push(line); line = w; } else line = t;
  });
  if (line) out.push(line);
  return out;
}

function drawFooter(ctx, lines, i, n) {
  const { W, H, M, FOOT } = PAGE;
  const y0 = H - FOOT + 10;
  ctx.strokeStyle = "#076633"; ctx.lineWidth = 1.2;
  ctx.beginPath(); ctx.moveTo(M, y0); ctx.lineTo(W - M, y0); ctx.stroke();
  ctx.fillStyle = "#475569"; ctx.font = "8.5px Arial"; ctx.textAlign = "center";
  const all = lines.flatMap((l) => wrap(ctx, l, W - 2 * M - 70)).slice(0, 5);
  all.forEach((l, k) => ctx.fillText(l, W / 2 - 30, y0 + 14 + k * 11));
  ctx.textAlign = "right"; ctx.font = "bold 9px Arial"; ctx.fillStyle = "#076633";
  ctx.fillText(`Page ${i} / ${n}`, W - M, y0 + 14);
}

// Rend l'en-tête + le corps HTML en pages A4 (images) identiques pour l'aperçu, l'impression et le PDF
export async function renderPages(headerEl, bodyEl, footerLines) {
  await Promise.all([...headerEl.querySelectorAll("img"), ...bodyEl.querySelectorAll("img")].map((im) => (im.complete ? null : new Promise((r) => { im.onload = r; im.onerror = r; }))));
  const { W, H, M, FOOT } = PAGE;
  const hc = await html2canvas(headerEl, { scale: SCALE, useCORS: true, backgroundColor: "#ffffff", logging: false });
  const headH = headerEl.offsetHeight;
  const contentTop = headH + 18;
  const contentH = H - contentTop - FOOT;
  const bc = await html2canvas(bodyEl, { scale: SCALE, useCORS: true, backgroundColor: "#ffffff", logging: false, windowWidth: W });
  const cuts = cutPoints(bodyEl, contentH);
  return cuts.map(([a, b], idx) => {
    const cv = document.createElement("canvas");
    cv.width = W * SCALE; cv.height = H * SCALE;
    const ctx = cv.getContext("2d");
    ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, cv.width, cv.height);
    ctx.drawImage(hc, 0, 0, hc.width, hc.height, 0, 0, W * SCALE, headH * SCALE);
    const h = Math.max(1, b - a);
    ctx.drawImage(bc, 0, a * SCALE, bc.width, h * SCALE, M * SCALE, contentTop * SCALE, bc.width, h * SCALE);
    ctx.setTransform(SCALE, 0, 0, SCALE, 0, 0);
    drawFooter(ctx, footerLines, idx + 1, cuts.length);
    return cv.toDataURL("image/jpeg", 0.92);
  });
}

export function pagesToPdf(pages) {
  const pdf = new jsPDF({ unit: "mm", format: "a4", compress: true });
  pages.forEach((p, i) => { if (i) pdf.addPage(); pdf.addImage(p, "JPEG", 0, 0, 210, 297); });
  return pdf;
}

export function printPages(pages, title) {
  const w = window.open("", "_blank");
  if (!w) { window.alert("Autorisez les fenêtres pop-up pour imprimer"); return; }
  w.document.write(`<html><head><title>${title}</title><style>@page{size:A4;margin:0}body{margin:0}img{width:210mm;height:297mm;display:block;page-break-after:always}</style></head><body>${pages.map((p) => `<img src="${p}"/>`).join("")}</body></html>`);
  w.document.close();
  w.onload = () => { w.focus(); w.print(); };
}
